module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "label"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.label.name,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('large-picture', {
    attrs: {
      "src": _vm.label.logo,
      "alt": _vm.label.nom_label
    }
  }), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('encyclopedia.info'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.status')))]), _vm._v(" "), (_vm.label.status) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.label.status))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.country')))]), _vm._v(" "), (_vm.label.country) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.label.country))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "nbAlbums"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.albums')))]), _vm._v(" "), (_vm.label.nbAlbums) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.label.nbAlbums))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "website"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.website')))]), _vm._v(" "), (_vm.label.website) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.getDomain(_vm.label.website)))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])])])], 1), _vm._v(" "), _c('section', {
    staticClass: "albums"
  }, [(_vm.albums.length > 0) ? _c('heading', {
    attrs: {
      "text": _vm.$tc('label.releases', _vm.albums.length),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }) : _vm._e(), _vm._v(" "), _c('list', {
    ref: "list",
    attrs: {
      "scroll": false,
      "items": _vm.albums,
      "link": "album",
      "fields": ['name', 'band', 'type', 'date'],
      "type": "img"
    }
  })], 1), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3524362b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Label.vue
// module id = 257
// module chunks = 0